var _desc, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIcLikedFull(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "18px",
    viewBox: "0 0 24 18",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "icLikedFull") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "See-comments",
    transform: "translate(-265.000000, -809.000000)",
    fill: "#77D700",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Reply",
    transform: "translate(76.000000, 702.000000)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M201.110757,109.090667 C201.703301,108.465333 202.409404,107.942 203.192669,107.576667 C203.976662,107.209333 204.838544,107 205.742647,107 C206.64675,107 207.508632,107.168 208.292625,107.471333 C209.076618,107.775333 209.781993,108.214667 210.374537,108.757333 C210.966353,109.3 211.447522,109.946667 211.778735,110.664667 C212.111404,111.382 212.294118,112.172 212.294118,113 C212.294118,113.828 212.110676,114.618 211.778735,115.335333 C211.447522,116.053333 210.967809,116.7 210.374537,117.242667 C209.782721,117.785333 201.431051,124.696 200.647059,125 C199.863066,124.696 191.511397,117.785333 190.918853,117.242667 C190.326309,116.7 189.846596,116.053333 189.514654,115.335333 C189.183441,114.618 189,113.828 189,113 C189,112.172 189.183441,111.382 189.514654,110.664667 C189.846596,109.946667 190.325581,109.3 190.918853,108.757333 C191.511397,108.214667 192.2175,107.775333 193.001493,107.471333 C193.784757,107.168 194.64664,107 195.551471,107 C196.456301,107 197.318184,107.209333 198.101449,107.575333 C198.885441,107.942 199.488163,108.304897 200.081435,108.93023 C200.673979,109.55623 200.517485,109.716667 201.110757,109.090667 Z",
    id: "icLikedFull"
  }))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLikedFull);
export default __webpack_public_path__ + "static/media/icLikedFull.8c144478c89c46bd0e9e4f1322848970.svg";
export { ForwardRef as ReactComponent };